'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'car-building';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f859';
var svgPathData = 'M272 0C298.5 0 320 21.49 320 48V136.4C290.5 148.5 266.9 173 256.3 204.6L255.9 205.1C254.9 198.1 248.2 192 240 192H208C199.2 192 192 199.2 192 208V240C192 248.8 199.2 256 208 256H239.2L233.6 272.9C208.5 290.2 192 319.2 192 352V480H48C21.49 480 0 458.5 0 432V48C0 21.49 21.49 0 48 0H272zM80 192C71.16 192 64 199.2 64 208V240C64 248.8 71.16 256 80 256H112C120.8 256 128 248.8 128 240V208C128 199.2 120.8 192 112 192H80zM80 96C71.16 96 64 103.2 64 112V144C64 152.8 71.16 160 80 160H112C120.8 160 128 152.8 128 144V112C128 103.2 120.8 96 112 96H80zM192 144C192 152.8 199.2 160 208 160H240C248.8 160 256 152.8 256 144V112C256 103.2 248.8 96 240 96H208C199.2 96 192 103.2 192 112V144zM80 288C71.16 288 64 295.2 64 304V336C64 344.8 71.16 352 80 352H112C120.8 352 128 344.8 128 336V304C128 295.2 120.8 288 112 288H80zM362.6 160H501.4C535.8 160 566.4 182 577.3 214.7L603.9 294.4C625.2 304.7 640 326.6 640 352L640 480C640 497.7 625.7 512 608 512H592C574.3 512 560 497.7 560 480V448H304V480C304 497.7 289.7 512 272 512H256C238.3 512 224 497.7 224 480L224 352C224 326.6 238.8 304.7 260.1 294.4L286.7 214.7C297.6 182 328.2 159.1 362.6 159.1V160zM362.6 224C355.7 224 349.6 228.4 347.4 234.9L329.7 288H534.3L516.6 234.9C514.4 228.4 508.3 224 501.4 224H362.6zM304 392C317.3 392 328 381.3 328 368C328 354.7 317.3 344 304 344C290.7 344 280 354.7 280 368C280 381.3 290.7 392 304 392zM560 344C546.7 344 536 354.7 536 368C536 381.3 546.7 392 560 392C573.3 392 584 381.3 584 368C584 354.7 573.3 344 560 344z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarBuilding = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;